module.exports = __webpack_public_path__ + "static/media/Step 10d-Scout.3d468563.png";